


import React from "react";
import img1 from "../../../assets/Akansha.jpeg";
import img2 from "../../../assets/Anjalii-21.jpg";
import img3 from "../../../assets/Gautam.png";
import img4 from "../../../assets/Aarti.jpg";
import img5 from "../../../assets/Aayush.jpg";
import img6 from "../../../assets/Aanchal.png";
import img7 from "../../../assets/Mansi.jpeg";
import img8 from "../../../assets/Priya.png";
import img9 from "../../../assets/Shivam.jpeg";
import img10 from "../../../assets/Shreya.jpg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

export default function Team() {
  const teamMembers = [
    { img: img2, name: "Anjali Kumari" , role:"Software Developer"  },
    { img: img3, name: "Gautam Kushwaha" , role:"Software Developer" },
    { img: img4, name: "Aarti Yadav" , role:"Software Developer"  },
    { img: img5, name: "Aayush Rajbhar" , role:"Software Developer"  },
    { img: img1, name: "Akanksha Mishra", role:"Software Developer" },
    { img: img9, name: "Shivam Kumar Sharma" , role:"Software Developer" },
    { img: img6, name: "Aanchal Kushwaha" , role:"Software Developer"  },
    { img: img7, name: "Mansi Chand kaushik" , role:"Software Developer"  },
    { img: img8, name: "Priya Rai" , role:"Software Developer" },
    { img: img10, name: "Shreya Singh" , role:"Software Developer" },
  ];

  return (
    <section className="pt-32 pb-4 text-center mx-auto bg-[linear-gradient(135deg,#05001a,#0a0133,#140145)]">
      <section className="px-6 md:px-20 py-20 bg-[ #20E0FF] text-white">

        <div className="flex items-center justify-between">
          <h1 className="text-center text-3xl font-bold w-full">TEAM</h1>
        </div>

        <div className="w-16 h-1 bg-red-600 mx-auto my-4 rounded"></div>

        <p className="text-center leading-8 max-w-xl6 mx-auto">
          <b>Our Expert Team</b><br />
          At CYBREDGE PRIVATE LIMITED, our strength lies in our talented and
          dedicated team of professionals who are passionate about innovation,
          technology, and cybersecurity. With expertise across multiple domains,
          our team works collaboratively to deliver high-quality solutions,
          ensuring trust, security, and excellence for every client.<br /><br />

          <b>What Makes Our Team Unique?</b><br />
          ◇ Highly skilled & certified technology professionals<br />
          ◇ Expertise in cybersecurity, infrastructure, software, and cloud engineering<br />
          ◇ Strong leadership and strategic problem-solving<br />
          ◇ Commitment to quality, transparency & customer success<br />
          ◇ Continuous learning & research-based innovation<br /><br />

          <b>Our Work Culture</b><br /><br />

          <b>We believe in a culture built on:</b><br />
          • Collaboration<br />
          • Integrity & Responsibility<br />
          • Creativity & Innovation<br />
          • Respect & Professional Growth<br />
          <br />
          Our team is always ready to take on challenges and deliver solutions that
          shape a secure digital future.
        </p>

        <div className="mt-12 w-full max-w-6xl mx-auto">
<div className="relative">
  <Swiper
    modules={[Navigation]}
    navigation={{
      prevEl: ".custom-prev",
      nextEl: ".custom-next",
    }}
    loop={true}
    slidesPerView={1}
    spaceBetween={30}
    breakpoints={{
      640: { slidesPerView: 2 },
      768: { slidesPerView: 4 },
      1024: { slidesPerView: 5 },
    }}
  >
    {teamMembers.map((member, i) => (
      <SwiperSlide key={i}>
        <div className="rounded-xl overflow-hidden bg-transparent shadow-lg">
          <div className="w-full aspect-[4/5] bg-gray-800 overflow-hidden">
            <img
              src={member.img}
              alt={member.name}
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="bg-[#353535] p-4 text-center">
            <p className="text-lg font-semibold text-white">{member.name}</p>
            <p className="text-sm text-gray-300">{member.role}</p>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>

 <button
  className="custom-prev absolute left-2 top-1/2 -translate-y-1/2 z-10
             bg-white/70 hover:bg-white w-10 h-10 rounded-full
             flex items-center justify-center text-xl font-bold shadow-md
             text-black hover:text-black"
>
  &#10094;
</button>

<button
  className="custom-next absolute right-2 top-1/2 -translate-y-1/2 z-10
             bg-white/70 hover:bg-white w-10 h-10 rounded-full
             flex items-center justify-center text-xl font-bold shadow-md
             text-black hover:text-black"
>
  &#10095;
</button>

</div>


        </div>

      </section>
    </section>
  );
}